import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IWorkItem } from '../../shared/workItem';
import { IWorkItemState } from '../../shared/workItemState';
import { CompareService } from '../compare.service';

@Component({
  selector: 'app-update-grid',
  templateUrl: './update-grid.component.html',
  styleUrls: ['./update-grid.component.css']
})
export class UpdateGridComponent implements OnInit {

  @Input() workitems: IWorkItem[];
  @Output() refresh = new EventEmitter();
  public workitemstates: IWorkItemState[];
  selectedCurrent: string = '';
  selectedNew: string = '';
    workItemTypeParent: string[] = ["PBI", "Product Backlog Item", "Bug", "Bug Pre Prod", "ProductBacklogItem"];

  constructor(private data: CompareService) { }

  ngOnInit() {

    this.data.getWorkItemStates("Connect")
      .subscribe(data => {
          this.workitemstates = data;
      });
  }

  selectedChangeHandlerCurrent(event: any) {
    this.selectedCurrent = event.target.value;
  }

  selectedChangeHandlerNew(event: any) {
    this.selectedNew = event.target.value;
  }

  updateState() {

    //create delegate to handle scope inside foreach
    var del = function (selcur, selnew, svc, workitemtypes, wi) {

      //first check if the work item type is a parent work item and not some sort of task
      if (workitemtypes.includes(wi.workItemType)) {
        if (selcur == "0" || wi.state == selcur) {
            if (selnew != "0") {
                var id = (wi.workItemId == null ? wi.id : wi.workItemId); //special condition to handle work item ID vs regular ID
                svc.updateWorkItemState(id, selnew).subscribe(() => { });
            }
        }
      }
    }

      this.workitems.forEach(del.bind(null, this.selectedCurrent, this.selectedNew, this.data, this.workItemTypeParent));

    this.refresh.emit(null);
  }

}
